import React from "react";
import { UserState } from "redux-oidc";
import { ImageGallery } from "../Common/ImageGallery";
import { ResourceRequest } from "../..";
import { TextDisplay } from "../../../Common";
import FeedbackFileDisplay from "../Common/FeedbackFileDisplay/FeedbackFileDisplay";
import { commentLinkSplitService } from "../../Services/CommentLinkSplitService";
import { userService } from "../../../User";

type Props = {
  feedback: ResourceRequest;
  user: UserState;
};

export const ResourceRequestDetails: React.FC<Props> = props => {
  const isCMUser = userService.isUserCadmakers(props.user);
  let { specSheetLink } = props.feedback;
  // sometimes users will add a link like "google.ca" instead of "http://google.ca"
  // we need to add the double slash in this case to let the browser know this is an external url
  if (specSheetLink && !specSheetLink.startsWith("http")) {
    specSheetLink = `//${specSheetLink}`;
  }

  return (
    <div>
      <div>
        <h4>Description</h4>
        <TextDisplay>
          {commentLinkSplitService.getLinkDisplay(props.feedback.description ?? "")}
        </TextDisplay>
      </div>
      <div>
        <h4>Category</h4>
        <TextDisplay>{props.feedback.categoryName}</TextDisplay>
      </div>
      <div>
        <h4>Spec Sheet Link</h4>
        {props.feedback.specSheetLink?.length && (
          <p>
            <a target="_blank" href={specSheetLink ?? ""} rel="noopener noreferrer">
              {props.feedback.specSheetLink}
            </a>
          </p>
        )}
      </div>
      {props.feedback.files.length > 0 && (
        <div>
          <h4>Files</h4>
          <FeedbackFileDisplay
            files={props.feedback.files.filter(f => isCMUser || !f.isCadmakersOnly)}
          />
          <br />
        </div>
      )}

      <ImageGallery images={props.feedback.images} />
    </div>
  );
};
